export default __webpack_public_path__ + "static/media/imgBanner.f3b8fe72.png";